<div class="flex items-center justify-self-center gap-2 mt-4 text-sm">
  <button
    type="button"
    (click)="onPrevClick()"
    [disabled]="currentPage === 1"
    class="px-3 py-1 text-dc-navy font-semibold disabled:opacity-50"
  >
    <i class="fas fa-angle-left px-2 transition-transform rtl:rotate-180"></i>
    {{ "PAGENATION.PRE" | translate }}
  </button>
  @for (item of paginationItems; track $index) {
    @if (item === 'ellipsis') {
      <span class="px-2 text-dc-gray-light select-none">...</span>
    } @else {
      <span
        (click)="onPageClick(item)"
        [ngClass]="{
          'text-dc-navy font-semibold': currentPage === item,
          'text-dc-gray-light': currentPage !== item
        }"
        class="py-1 cursor-pointer"
      >
        {{ item }}
      </span>
    }
  }
  <button
    type="button"
    (click)="onNextClick()"
    [disabled]="currentPage === totalPages"
    class="px-3 py-1 text-dc-navy disabled:opacity-50 font-semibold"
  >
    {{ "PAGENATION.NEXT" | translate }}
    <i class="fas fa-angle-right px-2 transition-transform rtl:rotate-180"></i>
  </button>
</div>
